import { Autocomplete, Button, Checkbox } from "@mui/material";
import CheckBoxOutlineBlankIcon from '@mui/icons-material/CheckBoxOutlineBlank';
import CheckBoxIcon from '@mui/icons-material/CheckBox';
import Grid from "@mui/material/Grid";
import FormControl from "@mui/material/FormControl";
import TextField from "@mui/material/TextField";
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogContentText from "@mui/material/DialogContentText";
import DialogTitle from '@mui/material/DialogTitle';
import { useSelector } from "react-redux";
import { closeDialogUser } from "../../../redux/reducers/dialogUser-reducer";
import { useDispatch } from "react-redux";
import { useEffect, useState, Fragment } from "react";
import { addUser, editUser, getUserById, deleteRestoreUser, resetPasswordUser } from "../../../const/CardDati";
import axios from "axios";
import { reloadingDataTableUsers } from "../../../redux/reducers/dataTableUsers-reducer";
import { useFormik } from "formik";
import * as yup from "yup";
import { dialogAddUser, dialogEditUser, dialogButtonGeneral, dialogButtonConfirm, changeStatusUserDialog, changeStatusUserTitleDialog } from "../../../const/DialogData";
import {notificationOpen}  from "../../../redux/reducers/notification-reducer";


const urlBase = process.env.REACT_APP_URL;


const UserDialog = () => {

  const stateUserRoles = useSelector(state => state.userRoles);
  const stateDevices = useSelector(state => state.devices);
  const [isRenderingDialog, setIsRenderingDialog] = useState(false);  
  const [changedRow, setchangedRow] = useState();
  const dialogState = useSelector((state) => state.dialogUser);
  const [selectedRoles, setSelectedRoles] = useState([]);
  const [disableSelectDevices, setDisableSelectDevices] = useState(false);
  const [inputRoleSelect, setInputRoleSelect] = useState('');
  const [selectedDevices, setSelectedDevices] = useState([]);
  const [inputDeviceSelect, setInputDeviceSelect] = useState('');
  const dispatch = useDispatch();
  const {rowInfo, dialogType} = dialogState;


  let validationSchema;
   
  if(dialogType === "edit"){
    validationSchema = yup.object({
      Username: yup
      .string()
      .required("Campo Obbligatorio."),
      Email: yup
      .string()
      .required("Campo Obbligatorio."),
      FirstName: yup
      .string()
      .required("Campo Obbligatorio."),
      LastName: yup
      .string()
      .required("Campo Obbligatorio.")
    });
  } else if(dialogType === "add"){
    validationSchema = yup.object({
      Username: yup
      .string()
      .required("Campo Obbligatorio."),
      Email: yup
      .string()
      .required("Campo Obbligatorio."),
      FirstName: yup
      .string()
      .required("Campo Obbligatorio."),
      LastName: yup
      .string()
      .required("Campo Obbligatorio."),
      Password: yup
      .string()
      .required("Campo Obbligatorio."),
      ConfirmPassword: yup
      .string()
      .required("Campo Obbligatorio."),
    });
  } else if(dialogType === "reset"){
    validationSchema = yup.object({
      Password: yup
      .string()
      .required("Campo Obbligatorio."),
      ConfirmPassword: yup
      .string()
      .required("Campo Obbligatorio."),
    });
  }
    

  let initialValues = {};
  const {
    id,
    firstName: FirstName,
    lastName: LastName,
    username: Username,
    Email,
    PhoneNumber,
    roles,
    dispositiviUtente,
    deleted
  } = rowInfo;



  useEffect(()=> {
    if(dialogType === 'edit' && rowInfo.roles.some(v => v === 'Amministratore')){
      setSelectedDevices([])
      setDisableSelectDevices(true)
     } else {
      setDisableSelectDevices(false)
     }
  },[rowInfo, dialogType])
  
  if(dialogType === "edit") {
    initialValues = {
      id: id,
      FirstName,
      LastName,
      Username,
      Email,
      PhoneNumber,
      roles,
      dispositiviUtente
    };
  } else if(dialogType === "add"){
    initialValues = {
      id: "",
      FirstName: "",
      LastName: "",
      Username: "",
      Email: "",
      PhoneNumber: "",
      roles: [],
      dispositiviUtente: [],
      Password: "",
      ConfirmPassword: ""
    };
  } else if(dialogType === "reset"){
    initialValues = {
      id: id,
      Password: "",
      ConfirmPassword: ""
    }
  } else if(dialogType === "delete"){
    initialValues = {
      id: id,
      FirstName,
      LastName,
      Username
    }
  }
  
  const formik = useFormik({
    initialValues,
    validationSchema: validationSchema,
    enableReinitialize: true, // rinizializza il valore che gli viene passato con rowInfo
    onSubmit: (values) => {
      if(dialogType === "edit"){
        setchangedRow({
          id: values.id,
          FirstName: values.FirstName,
          LastName: values.LastName,
          Username: values.Username,
          Email: values.Email,
          PhoneNumber: values.PhoneNumber,
          roles: selectedRoles,
          dispositiviUtente: selectedDevices
        });
      } else if(dialogType === "add"){
        setchangedRow({
          FirstName: values.FirstName,
          LastName: values.LastName,
          Username: values.Username,
          Email: values.Email,
          PhoneNumber: values.PhoneNumber,
          Password: values.Password,
          ConfirmPassword: values.ConfirmPassword,
          roles: selectedRoles,
          dispositiviUtente: selectedDevices
        });
      } else if(dialogType === "reset"){
        setchangedRow({
          id: values.id,
          Password: values.Password,
          ConfirmPassword: values.ConfirmPassword
        });
      }      
    }
  });


  const handleChangeRoleSelect = (event, value) => {
    setSelectedRoles(value);
    let hasAdminRole = value.some(v => v.description === 'Amministratore')
    if(hasAdminRole){
      setSelectedDevices([]);
    } 
    setDisableSelectDevices(hasAdminRole);
  };

  const handleInputChangeRoleSelect = (event, value) => {
    setInputRoleSelect(value);
  };

  const handleChangeDeviceSelect = (event, value) => {
    setSelectedDevices(value);
  };
  
  const handleInputChangeDeviceSelect = (event, value) => {
    setInputDeviceSelect(value);
  };


  useEffect(() => {
    if (dialogState.isOpen && dialogType === "edit") {
      (async () => {
        setSelectedRoles([]);
        setSelectedDevices([]);
        setIsRenderingDialog(true);
        
        const { action, method } = getUserById;
        let url = urlBase + action + id;

        try {

          const response = await axios({
            method: method,
            url
          });

          if (response.data.ok) {
            dispatch(reloadingDataTableUsers());
            let keyUp
            Object.keys(response.data.result).map((key) => {
                 keyUp = key.charAt(0).toUpperCase() + key.slice(1);
              
              if (key === "ruoliUtente" && response.data.result[key].length > 0 ) {
                  formik.setFieldValue(`${[keyUp]}`, setSelectedRoles(response.data.result[key]), true);
              } 

              if (key === "dispositiviUtente" && response.data.result[key].length > 0 ) {
                formik.setFieldValue(`${[keyUp]}`, setSelectedDevices(response.data.result[key]), true);
              }               
              formik.setFieldValue(`${[keyUp]}`, `${response.data.result[key]}`, true);
            });

            setIsRenderingDialog(false);

          } else {
            dispatch(notificationOpen({message:response.data.message,status:response.data.ok }));          
          }

        } catch(error){
          console.error(error);
          if (error.response) {
            dispatch(notificationOpen({message:`${error.response.data.message}`, status:error.ok }));
          } else {
            dispatch(notificationOpen({message:"Operazione fallita: Server non raggiungibile.", status:false }));
          }
        }
        setIsRenderingDialog(false);
      })();
    }
  }, [dialogState.isOpen]);
  
  const closeForm = () => {
    formik.resetForm(initialValues)
    dispatch(closeDialogUser());
  }

  const change = (rowInfo) => {
    if (dialogState.dialogType === "delete"){
      const { id } = rowInfo;
      setchangedRow({
        userId:id
      });
      dispatch(closeDialogUser());
    }

    return changedRow;
  };

  useEffect(() => {
    if (changedRow != null) {
      (async () => {

        let listIdRole, listIdDevices, formData, action, method, url;

        if(dialogType === "add" || dialogType === "edit"){
          listIdRole = selectedRoles.map(role => role.id);
          listIdDevices = selectedDevices.map(device => device.id);
          formData = {...changedRow, roles: listIdRole, idDevices: listIdDevices};

          if(dialogType === "edit"){
            action = editUser.action;
            method = editUser.method;
          } else {
            action = addUser.action;
            method = addUser.method;
          }

          url = urlBase + action;
        } else if(dialogType === "reset"){
          formData = {...changedRow};
          action = resetPasswordUser.action;
          method = resetPasswordUser.method;
          url = urlBase + action;
        }

        try {
          const response = await axios({
            method: method,
            url,
            data: formData
          });

          if (response.data.ok) {
            dispatch(reloadingDataTableUsers());
            dispatch(closeDialogUser());
          } 
          dispatch(notificationOpen({message:response.data.message,status:response.data.ok }))          
        } catch(error){
          console.error(error);
          if (error?.response?.data?.errors != undefined ){
            let keys = Object.keys(error?.response?.data?.errors)
            keys.map(key => {
              formik.setFieldError(key,error?.response?.data?.errors[key])
            })
          }
        }
      })();
    }
  }, [changedRow]);

  const deleteRestore = (rowInfo) => {
    if (dialogState.dialogType === "delete") {
      (async () => {
        setIsRenderingDialog(true);
        
        const { id } = rowInfo;
        const { action, method } = deleteRestoreUser;
        let url = urlBase + action ;

        try {
          const response = await axios({
            method: method,
            url,
            data: id,
            headers: {
              'Content-Type': 'application/json'
            }
          });

          if (response.data.ok) {
            dispatch(reloadingDataTableUsers());
            setIsRenderingDialog(false);
          } 

          dispatch(notificationOpen({message:response.data.message, status:response.data.ok })); 

        }
        catch(error){
          console.error(error);
          if (error.response) {
            dispatch(notificationOpen({message:`${error.response.data.message}`, status:error.ok }));
          } else {
            dispatch(notificationOpen({message:"Operazione fallita: Server non raggiungibile.", status:false }));
          }
        }
        setIsRenderingDialog(false);

      })();
      
      dispatch(closeDialogUser());
    }
  };

  useEffect(() => {
    setSelectedRoles([]);
    setSelectedDevices([]);
  }, [dialogState.isOpen]);


  const handlerBlur = (e) => {
    if (!e.currentTarget.contains(e.relatedTarget)) {
      closeForm();
    }
  }

  return (
    <>
      {dialogState.dialogType === "delete" && (
        <>
          <Dialog
            open={dialogState.isOpen}
            onClose={() => dispatch(closeDialogUser())}
            aria-labelledby="alert-dialog-title"
            aria-describedby="alert-dialog-description"
          >
            <DialogTitle>
              {changeStatusUserTitleDialog(deleted)}
            </DialogTitle>
            <DialogContent>
              <DialogContentText id="alert-dialog-description">
                {changeStatusUserDialog(deleted)} l'utente <b>{FirstName} {LastName} ({Username})</b>?
              </DialogContentText>
            </DialogContent>
            <DialogActions>
              <Button onClick={() => dispatch(closeDialogUser())}>
              {dialogButtonConfirm.Cancel}
                </Button>
              <Button onClick={() => deleteRestore(rowInfo)} autoFocus>
              {dialogButtonConfirm.Confirm}
              </Button>
            </DialogActions>
          </Dialog>
        </>
      )}
      {(dialogState.dialogType === "add" || dialogState.dialogType === "edit") && !isRenderingDialog && (
        <>
          <Dialog
            open={dialogState.isOpen}
            onClose={() => dispatch(closeDialogUser())}
            aria-labelledby="alert-dialog-title"
            aria-describedby="alert-dialog-description"
            fullWidth
            maxWidth={'sm'}
          >
            <DialogTitle >{dialogState.dialogType === "edit" ? dialogEditUser.DialogTitle : dialogAddUser.DialogTitle }</DialogTitle>
            <DialogContent>
              <form onSubmit={formik.handleSubmit}>
                <FormControl fullWidth>
                {dialogState.dialogType === "edit" && (
                    <TextField
                      margin="dense"
                      id="id"
                      label="ID Utente"
                      type="text"
                      fullWidth
                      variant="standard"
                      value={formik.values.id}
                      sx={{display:'none'}}
                    />
                  )}
                  <Grid container rowSpacing={1} columnSpacing={2}>
                    <Grid item xs={12} sm={12}>
                      <TextField
                        margin="dense"
                        id="Username"
                        label="Username"
                        type="text"
                        fullWidth
                        autoFocus
                        variant="standard"
                        value={formik.values.Username}
                        onChange={formik.handleChange("Username")}
                        error={
                          formik.touched.Username &&
                          Boolean(formik.errors.Username)
                        }
                        helperText={
                          formik.touched.Username &&
                          formik.errors.Username
                        }
                        inputProps={{
                          autoComplete: 'new-Password',
                          form: {
                            autoComplete: 'off',
                          }
                        }}
                      />
                    </Grid>
                    <Grid item xs={12} sm={6}>
                      <TextField
                        margin="dense"
                        id="FirstName"
                        label="Nome"
                        type="text"
                        fullWidth
                        variant="standard"
                        value={formik.values.FirstName}
                        onChange={formik.handleChange("FirstName")}
                        error={
                          formik.touched.FirstName &&
                          Boolean(formik.errors.FirstName)
                        }
                        helperText={
                          formik.touched.FirstName &&
                          formik.errors.FirstName
                        }
                      />
                    </Grid>
                    <Grid item xs={12} sm={6}>
                      <TextField
                        margin="dense"
                        id="LastName"
                        label="Cognome"
                        type="text"
                        fullWidth
                        variant="standard"
                        value={formik.values.LastName}
                        onChange={formik.handleChange("LastName")}
                        error={
                          formik.touched.LastName &&
                          Boolean(formik.errors.LastName)
                        }
                        helperText={
                          formik.touched.LastName &&
                          formik.errors.LastName
                        }
                      />
                    </Grid>
                    <Grid item xs={12} sm={6}>
                      <TextField
                        margin="dense"
                        id="Email"
                        label="Email"
                        type="text"
                        fullWidth
                        variant="standard"
                        value={formik.values.Email}
                        onChange={formik.handleChange("Email")}
                        error={
                          formik.touched.Email &&
                          Boolean(formik.errors.Email)
                        }
                        helperText={
                          formik.touched.Email &&
                          formik.errors.Email
                        }
                        inputProps={{
                          autoComplete: 'new-Password',
                          form: {
                            autoComplete: 'off',
                          }
                        }}
                      />
                    </Grid>
                    <Grid item xs={12} sm={6}>
                      <TextField
                        margin="dense"
                        id="PhoneNumber"
                        label="Numero Telefono"
                        type="text"
                        fullWidth
                        variant="standard"
                        value={formik.values.PhoneNumber}
                        onChange={formik.handleChange("PhoneNumber")}
                        error={
                          formik.touched.PhoneNumber &&
                          Boolean(formik.errors.PhoneNumber)
                        }
                        helperText={
                          formik.touched.PhoneNumber &&
                          formik.errors.PhoneNumber
                        }
                      />
                    </Grid>
                    {dialogState.dialogType === "add" && (
                    <>
                      <Grid item xs={12} sm={6}>
                        <TextField
                          margin="dense"
                          id="Password"
                          label="Password"
                          type="Password"
                          fullWidth
                          variant="standard"
                          value={formik.values.Password}
                          onChange={formik.handleChange("Password")}
                          error={
                            formik.touched.Password &&
                            Boolean(formik.errors.Password)
                          }
                          helperText={
                            formik.touched.Password &&
                            formik.errors.Password
                          }
                          inputProps={{
                          autoComplete: 'new-Password',
                          form: {
                            autoComplete: 'off',
                          }
                        }}
                      />
                      </Grid>
                      <Grid item xs={12} sm={6}>
                        <TextField
                          margin="dense"
                          id="ConfirmPassword"
                          label="Conferma Password"
                          type="Password"
                          fullWidth
                          variant="standard"
                          value={formik.values.ConfirmPassword}
                          onChange={formik.handleChange("ConfirmPassword")}
                          error={
                            formik.touched.ConfirmPassword &&
                            Boolean(formik.errors.ConfirmPassword)
                          }
                          helperText={
                            formik.touched.ConfirmPassword &&
                            formik.errors.ConfirmPassword
                          }
                          inputProps={{
                            autoComplete: 'new-Password',
                            form: {
                              autoComplete: 'off',
                            }
                          }}
                        />
                      </Grid>
                     </>
                    )} 
                    <Grid item xs={12} sm={12}>
                      <Autocomplete
                        multiple
                        id="roles"
                        size="small"
                        options={stateUserRoles}
                        value={selectedRoles}
                        disableCloseOnSelect
                        limitTags={1}
                        isOptionEqualToValue={(option, value) => option.id === value.id}
                        getOptionLabel={(option) => option.description}
                        onChange={handleChangeRoleSelect}
                        onInputChange={handleInputChangeRoleSelect}
                        renderOption={(props, option, { selected }) => (
                          <li {...props}>
                            <Checkbox
                              icon={<CheckBoxOutlineBlankIcon fontSize="small" />}
                              checkedIcon={<CheckBoxIcon fontSize="small" />}
                              style={{ marginRight: 8 }}
                              checked={selected}
                            />
                            {option.description}
                          </li>
                        )}
                        renderInput={(params) =>  (
                            <TextField {...params} label="Ruoli Assegnati" variant="standard" InputProps={
                              {
                              ...params.InputProps,
                              endAdornment: (
                                <Fragment>
                                  {params.InputProps.endAdornment}
                                </Fragment>
                              )
                          }}
                          />)
                        }
                      />
                    </Grid>
                    <Grid item xs={12} sm={12}>
                      <Autocomplete
                        multiple
                        id="devices"
                        size="small"
                        options={stateDevices}
                        value={selectedDevices}
                        disableCloseOnSelect
                        limitTags={1}
                        disabled={disableSelectDevices}
                        isOptionEqualToValue={(option, value) => option.id === value.id}
                        getOptionLabel={(option) => option.denominazione}
                        onChange={handleChangeDeviceSelect}
                        onInputChange={handleInputChangeDeviceSelect}
                        renderOption={(props, option, { selected }) => (
                          <li {...props}>
                            <Checkbox
                              icon={<CheckBoxOutlineBlankIcon fontSize="small" />}
                              checkedIcon={<CheckBoxIcon fontSize="small" />}
                              style={{ marginRight: 8 }}
                              checked={selected}
                            />
                            {option.denominazione}
                          </li>
                        )}
                        renderInput={(params) =>  (
                            <TextField {...params} label="Dispositivi" variant="standard" InputProps={
                              {
                                ...params.InputProps,
                                endAdornment: (
                                  <Fragment>
                                    {params.InputProps.endAdornment}
                                  </Fragment>
                                )
                              }}
                          />)
                        }
                      />
                    </Grid>
                  </Grid>                   
                </FormControl>
                <DialogActions sx={{mt: 3}}>
                  <Button onClick={() => closeForm()}>
                    {dialogButtonGeneral.Cancel}
                  </Button>
                  <Button
                    type="submit"
                    onClick={() => change(rowInfo)}
                  >
                    {dialogButtonGeneral.Confirm}
                  </Button>
                </DialogActions>
              </form>
            </DialogContent>
          </Dialog>
        </>
      )}
      {dialogState.dialogType === "reset" && (
        <>
          <Dialog
            open={dialogState.isOpen}
            onClose={() => dispatch(closeDialogUser())}
            aria-labelledby="alert-dialog-title"
            aria-describedby="alert-dialog-description"
            fullWidth
            maxWidth={'sm'}
            onBlur={(e) =>handlerBlur(e)}
          >
            <DialogTitle >Reset password</DialogTitle>
            <DialogContent>
              <form onSubmit={formik.handleSubmit}>
                  <FormControl fullWidth>
                    <TextField
                      margin="dense"
                      id="id"
                      label="ID Utente"
                      type="text"
                      fullWidth
                      variant="standard"
                      value={formik.values.id}
                      sx={{display:'none'}}
                    />
                    <TextField
                        margin="dense"
                        id="Password"
                        label="Nuova Password"
                        type="Password"
                        fullWidth
                        autoFocus
                        variant="standard"
                        value={formik.values.Password}
                        onChange={formik.handleChange("Password")}
                        error={
                          formik.touched.Password &&
                          Boolean(formik.errors.Password)
                        }
                        helperText={
                          formik.touched.Password &&
                          formik.errors.Password
                        }
                      />
                      <TextField
                        margin="dense"
                        id="ConfirmPassword"
                        label="Conferma Password"
                        type="Password"
                        fullWidth
                        variant="standard"
                        value={formik.values.ConfirmPassword}
                        onChange={formik.handleChange("ConfirmPassword")}
                        error={
                          formik.touched.ConfirmPassword &&
                          Boolean(formik.errors.ConfirmPassword)
                        }
                        helperText={
                          formik.touched.ConfirmPassword &&
                          formik.errors.ConfirmPassword
                        }
                      />
                  </FormControl>
                  <DialogActions>
                    <Button onClick={() => closeForm()}>
                      {dialogButtonGeneral.Cancel}
                    </Button>
                    <Button
                      type="submit"
                      onClick={() => change(rowInfo)}
                    >
                      {dialogButtonGeneral.Confirm}
                    </Button>
                  </DialogActions>
              </form>
            </DialogContent>
          </Dialog>
        </>
      )}
    </>
  );
};

export default UserDialog;
